<div class="p500-ui-modal__footer">
  <a [href]="controlLink" class="c-link" target="_blank">
    <button type="button" p500-ui-button>Go to Profile</button>
  </a>
</div>
